import React from 'react'
import styled from 'styled-components'
import convertUnit from 'lib/unit'
import {Icon} from '../Icon'
import {ButtonHeaderProps} from './ButtonHeaderProps'

interface StyledContainerProps {
  useDefaultMargin: boolean
  useDefaultPadding: boolean
  disabled?: boolean
}

const StyledContainer = styled.div<StyledContainerProps>`
  ${({theme, useDefaultMargin, useDefaultPadding, disabled}) => ({
    color: theme.primary_5,
    margin: useDefaultMargin ? `0 ${convertUnit(4)}` : undefined,
    padding: useDefaultPadding ? convertUnit(12) : undefined,
    ':hover': {
      color: theme.primary_4,
      cursor: disabled ? 'default' : 'pointer',
      opacity: disabled ? 1 : 0.5,
    },
  })}
  transition: all 0.15s ease-out;
`

export default function ButtonHeader({
  icon,
  disabled = false,
  useDefaultMargin = true,
  useDefaultPadding = true,
  size = 24,
  color,
  onClick,
  ...props
}: ButtonHeaderProps) {
  return (
    <StyledContainer
      {...props}
      disabled={disabled}
      useDefaultMargin={useDefaultMargin}
      useDefaultPadding={useDefaultPadding}
      onClick={disabled ? undefined : onClick}>
      <Icon type={icon} size={convertUnit(size)} color={color || 'inherit'} />
    </StyledContainer>
  )
}
